var render = function render(){var _vm=this,_c=_vm._self._c;return _c('booking-form',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.fullscreenLoading),expression:"fullscreenLoading",modifiers:{"fullscreen":true,"lock":true}}],attrs:{"booking":_vm.booking,"type":"edit"},on:{"save":_vm.editBooking,"cancel":_vm.cancelEditBooking,"delete":_vm.deleteBooking}})
}
var staticRenderFns = []

export { render, staticRenderFns }